module.exports = __webpack_public_path__ + "img/zixun_5@2x.16ea7609.png";